// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Standard alignment for breadcrumbs and product list */
.breadcrumb-align-standard {
  margin-left: 2vw;
  margin-right: 0;
  max-width: 900px;
  width: 100%;
  box-sizing: border-box;
}
@media (max-width: 900px) {
  .breadcrumb-align-standard {
    margin-left: 4vw;
    max-width: 100%;
  }
}
@media (max-width: 600px) {
  .breadcrumb-align-standard {
    margin-left: 2vw;
    padding-left: 0;
    padding-right: 0;
  }
  .breadcrumb-productlist-row {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
    margin-left: 0;
    margin-right: 0;
    width: 100%;
  }
  .productlist-title {
    font-size: 18px;
    margin-top: 2px;
  }
  .breadcrumb-text {
    font-size: 12px;
  }
}
/* View More button for description */
.view-more-btn {
  background: none;
  border: none;
  color: #004996;
  cursor: pointer;
  font-size: 14px;
  margin-top: 2px;
  padding: 0;
  text-decoration: underline;
  transition: color 0.2s;
}
.view-more-btn:hover {
  color: #002d5c;
}
/* Clamp product description to 2 lines with ellipsis */
.product-description-clamp {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
  min-height: 2.6em;
  max-width: 100%;
}
/* Breadcrumb and Product List Responsive Styles */
.breadcrumb-productlist-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
  margin-bottom: 12px;
  margin-left: 0;
  margin-right: 0;
}
.breadcrumb-productlist-col {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-right: 80px;
}
.breadcrumb-text {
  margin: 0;
  color: #6b7280;
  font-size: 14px;
}
.productlist-title {
  margin: 6px 0 0 0;
  font-size: 22px;
  color: #111827;
  margin-right: 80px;
}
@media (max-width: 600px) {
  .breadcrumb-productlist-row {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
    margin-left: 0;
    margin-right: 0;
  }
  .productlist-title {
    font-size: 18px;
    margin-top: 2px;
  }
  .breadcrumb-text {
    font-size: 12px;
  }
}

/* Video text overflow fix */
.video-text-responsive {
  width: 100%;
  min-width: 0;
  word-break: normal;
  overflow-wrap: break-word;
  max-width: 100%;
}
.video-title-responsive {
  font-size: clamp(1rem, 2.5vw, 1.2rem);
  margin: 0 0 6px;
  white-space: normal;
  overflow-wrap: break-word;
  line-height: 1.35;
}
.video-desc-responsive {
  font-size: clamp(0.8rem, 2vw, 1rem);
  white-space: normal;
  overflow-wrap: break-word;
  line-height: 1.5;
  margin: 0;
}

.videoCard.product-video-card {
  display: flex !important;
  flex-direction: column !important;
  align-items: stretch !important;
  gap: 10px;
}

.videoCard.product-video-card .product-video-frame {
  width: 100% !important;
  max-width: 100% !important;
  min-height: 200px;
  border-radius: 10px;
}

.product-video-meta {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: 100%;
  min-width: 0;
}

@media (max-width: 900px) {
  .videoCard.product-video-card .product-video-frame {
    min-height: 180px;
  }
}
.cards-sect {
  display: grid;
    grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
    gap: 15px;
    margin-top: 20px;
}

.cards__items {
  flex: 1 1 180px; /* Grow, shrink, basis */
  min-width: 150px;
  max-width: 220px;
}

.card-menu {
  background-color: #ffffff;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 15px;
  height: max-content !important;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: auto;
  /* box-shadow: 0 2px 5px rgba(0,0,0,0.05); */
  transition: all 0.3s ease;
}

.card__contents {
  display: flex;
  flex-direction: column;
}

.card__types {
  font-size: 0.7rem;
  color: #888;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  font-weight: 600;
  margin-bottom: 5px;
}


`, "",{"version":3,"sources":["webpack://./src/assets/styles/productDetailCard.css"],"names":[],"mappings":"AAAA,wDAAwD;AACxD;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,sBAAsB;AACxB;AACA;EACE;IACE,gBAAgB;IAChB,eAAe;EACjB;AACF;AACA;EACE;IACE,gBAAgB;IAChB,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;IACR,cAAc;IACd,eAAe;IACf,WAAW;EACb;EACA;IACE,eAAe;IACf,eAAe;EACjB;EACA;IACE,eAAe;EACjB;AACF;AACA,qCAAqC;AACrC;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,eAAe;EACf,eAAe;EACf,UAAU;EACV,0BAA0B;EAC1B,sBAAsB;AACxB;AACA;EACE,cAAc;AAChB;AACA,uDAAuD;AACvD;EACE,oBAAoB;EACpB,qBAAqB;EACrB,aAAa;EACb,4BAA4B;EAC5B,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;AACjB;AACA,kDAAkD;AAClD;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,kBAAkB;AACpB;AACA;EACE,SAAS;EACT,cAAc;EACd,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;AACA;EACE;IACE,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;IACR,cAAc;IACd,eAAe;EACjB;EACA;IACE,eAAe;IACf,eAAe;EACjB;EACA;IACE,eAAe;EACjB;AACF;;AAEA,4BAA4B;AAC5B;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;AACjB;AACA;EACE,qCAAqC;EACrC,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,iBAAiB;AACnB;AACA;EACE,mCAAmC;EACnC,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,wBAAwB;EACxB,iCAAiC;EACjC,+BAA+B;EAC/B,SAAS;AACX;;AAEA;EACE,sBAAsB;EACtB,0BAA0B;EAC1B,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,WAAW;EACX,YAAY;AACd;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;AACA;EACE,aAAa;IACX,2DAA2D;IAC3D,SAAS;IACT,gBAAgB;AACpB;;AAEA;EACE,eAAe,EAAE,wBAAwB;EACzC,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,gBAAgB;EAChB,4CAA4C;EAC5C,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;AACpB","sourcesContent":["/* Standard alignment for breadcrumbs and product list */\n.breadcrumb-align-standard {\n  margin-left: 2vw;\n  margin-right: 0;\n  max-width: 900px;\n  width: 100%;\n  box-sizing: border-box;\n}\n@media (max-width: 900px) {\n  .breadcrumb-align-standard {\n    margin-left: 4vw;\n    max-width: 100%;\n  }\n}\n@media (max-width: 600px) {\n  .breadcrumb-align-standard {\n    margin-left: 2vw;\n    padding-left: 0;\n    padding-right: 0;\n  }\n  .breadcrumb-productlist-row {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 8px;\n    margin-left: 0;\n    margin-right: 0;\n    width: 100%;\n  }\n  .productlist-title {\n    font-size: 18px;\n    margin-top: 2px;\n  }\n  .breadcrumb-text {\n    font-size: 12px;\n  }\n}\n/* View More button for description */\n.view-more-btn {\n  background: none;\n  border: none;\n  color: #004996;\n  cursor: pointer;\n  font-size: 14px;\n  margin-top: 2px;\n  padding: 0;\n  text-decoration: underline;\n  transition: color 0.2s;\n}\n.view-more-btn:hover {\n  color: #002d5c;\n}\n/* Clamp product description to 2 lines with ellipsis */\n.product-description-clamp {\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: normal;\n  min-height: 2.6em;\n  max-width: 100%;\n}\n/* Breadcrumb and Product List Responsive Styles */\n.breadcrumb-productlist-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  flex-wrap: wrap;\n  margin-bottom: 12px;\n  margin-left: 0;\n  margin-right: 0;\n}\n.breadcrumb-productlist-col {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  margin-right: 80px;\n}\n.breadcrumb-text {\n  margin: 0;\n  color: #6b7280;\n  font-size: 14px;\n}\n.productlist-title {\n  margin: 6px 0 0 0;\n  font-size: 22px;\n  color: #111827;\n  margin-right: 80px;\n}\n@media (max-width: 600px) {\n  .breadcrumb-productlist-row {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 8px;\n    margin-left: 0;\n    margin-right: 0;\n  }\n  .productlist-title {\n    font-size: 18px;\n    margin-top: 2px;\n  }\n  .breadcrumb-text {\n    font-size: 12px;\n  }\n}\n\n/* Video text overflow fix */\n.video-text-responsive {\n  width: 100%;\n  min-width: 0;\n  word-break: normal;\n  overflow-wrap: break-word;\n  max-width: 100%;\n}\n.video-title-responsive {\n  font-size: clamp(1rem, 2.5vw, 1.2rem);\n  margin: 0 0 6px;\n  white-space: normal;\n  overflow-wrap: break-word;\n  line-height: 1.35;\n}\n.video-desc-responsive {\n  font-size: clamp(0.8rem, 2vw, 1rem);\n  white-space: normal;\n  overflow-wrap: break-word;\n  line-height: 1.5;\n  margin: 0;\n}\n\n.videoCard.product-video-card {\n  display: flex !important;\n  flex-direction: column !important;\n  align-items: stretch !important;\n  gap: 10px;\n}\n\n.videoCard.product-video-card .product-video-frame {\n  width: 100% !important;\n  max-width: 100% !important;\n  min-height: 200px;\n  border-radius: 10px;\n}\n\n.product-video-meta {\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  width: 100%;\n  min-width: 0;\n}\n\n@media (max-width: 900px) {\n  .videoCard.product-video-card .product-video-frame {\n    min-height: 180px;\n  }\n}\n.cards-sect {\n  display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));\n    gap: 15px;\n    margin-top: 20px;\n}\n\n.cards__items {\n  flex: 1 1 180px; /* Grow, shrink, basis */\n  min-width: 150px;\n  max-width: 220px;\n}\n\n.card-menu {\n  background-color: #ffffff;\n  border: 1px solid #e0e0e0;\n  border-radius: 8px;\n  padding: 15px;\n  height: max-content !important;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  min-height: auto;\n  /* box-shadow: 0 2px 5px rgba(0,0,0,0.05); */\n  transition: all 0.3s ease;\n}\n\n.card__contents {\n  display: flex;\n  flex-direction: column;\n}\n\n.card__types {\n  font-size: 0.7rem;\n  color: #888;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  font-weight: 600;\n  margin-bottom: 5px;\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
